import { t } from '@lingui/macro'
import { Badge, IconButton, Tooltip } from '@mui/material'
import { Filter } from 'lucide-react'
import React from 'react'

interface FilterIconButtonProps {
    onClick: () => void
    hasActiveFilters: boolean
}

export const FilterIconButton: React.FC<FilterIconButtonProps> = ({ onClick, hasActiveFilters }) => {
    return (
        <Tooltip title={t`Open Filters`}>
            <Badge
                variant='dot'
                color='error'
                invisible={!hasActiveFilters}
                sx={{
                    '& .MuiBadge-dot': {
                        right: 6,
                        top: 6
                    }
                }}
            >
                <IconButton
                    onClick={onClick}
                    size='small'
                    sx={{
                        border: '1px solid',
                        borderColor: 'divider',
                        borderRadius: '8px',
                        color: 'inherit',
                        '&:hover': {
                            backgroundColor: 'action.hover'
                        }
                    }}
                >
                    <Filter size={20} />
                </IconButton>
            </Badge>
        </Tooltip>
    )
}

export default FilterIconButton
